import { render, staticRenderFns } from "./_category.vue?vue&type=template&id=5a8aff0c&"
import script from "./_category.vue?vue&type=script&lang=js&"
export * from "./_category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports